import React from 'react';
import {COLORS} from '@fupa/fupa-uikit';
import {
  StreamIcon,
  Category,
  Container,
  Header,
  Line,
  Timestamp,
  CategoryName,
  MessageHeading,
} from 'app/styles/stream';
import {formatShortDate} from 'app/helpers/dateHelpers';
import {Group, InsertComment, Person} from '@mui/icons-material';
import {Coach, Emblem} from 'app/components/icons';

const MarketplaceHeader = ({element}) => {
  const Time = <Timestamp>{formatShortDate(element.timestamp)}</Timestamp>;

  const icon = {
    searchingopponent: <Group color='icon-invert' fontSize='inherit' />,
    searchingclub: <Emblem style={{color: COLORS.white, fontSize: 16}} />,
    searchingcoach: <Coach color='icon-invert' fontSize='inherit' />,
    searchingplayer: <Group color='icon-invert' fontSize='inherit' />,
    clubsearching: <Emblem style={{color: COLORS.white, fontSize: 16}} />,
    coachsearching: <Coach color='icon-invert' fontSize='inherit' />,
    playersearching: <Person color='icon-invert' fontSize='inherit' />,
    other: <InsertComment color='icon-invert' fontSize='inherit' />,
  };

  const getSubHeading = (anonymous, category) => {
    if (anonymous) {
      return 'Anonym';
    } else if (category === 'other') {
      return element.club
        ? element.club.name
        : element.author
        ? element.author.firstName + ' ' + element.author.lastName
        : 'Unbekannt';
    } else if (category === 'coachsearching' || category === 'playersearching' || category === 'searchingclub') {
      return element.author ? element.author.firstName + ' ' + element.author.lastName : 'Unbekannt';
    } else {
      return element.club ? element.club.name : 'Unbekannt';
    }
  };

  const subHeading = getSubHeading(element.anonymous, element.category.slug);

  return (
    <Header variant='caption3'>
      <Container>
        <StreamIcon color={COLORS.marketBlue}>{icon[element.category.slug]}</StreamIcon>
        <Category>
          <CategoryName>{element.category.name}</CategoryName>
          <MessageHeading>{subHeading}</MessageHeading>
        </Category>
        {Time}
      </Container>
      <Line />
    </Header>
  );
};

export default MarketplaceHeader;
